<template>
    <div id="contact">
        <v-card-subtitle class="font-weight-bold pt-5 pb-0">
            <v-icon :color="subAppColor" left>mdi-account-box</v-icon> Contact Information
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.homePhone" readonly hide-details label="Home Phone"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.cellPhone" readonly hide-details label="Cell Phone"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.email" readonly hide-details label="Email"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="item.emailPersonal" label="Email (Personal)" placeholder="Not Available" readonly hide-details>
                        </v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="item.emailPersonalConfirmed" label="Confirm Email (Personal)" placeholder="Not Available" readonly hide-details>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-contact',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>